import {
  apiClient,
  type ShipmentOrderImportValidationEntity,
  type ValidateShipmentOrderImportDto
} from '@/libs/api'

/**
 * 事前チェック（取り込まずにサーバー側の検証だけを走らせる）。ジョブは作らず、DB にも書かない。
 * setting を省略すると通常フォーマットとして読む。
 */
export const validateShipmentOrderImport = async (
  tenantKey: string,
  body: ValidateShipmentOrderImportDto,
  signal?: AbortSignal
): Promise<ShipmentOrderImportValidationEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_jobs.validate.$post({ body, config: { signal } })
  return data
}
